module.exports = __webpack_public_path__ + "img/sonar-logo.bd14e0d6.png";